import { Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import ReadOnlyRowPOS from './components/ReadOnlyRow';
import ConfirmDialog from './components/ConfirmDialog';
import { borrarProveedor } from '../../../../actions/proveedores';


const TablaProveedores = ({ currentUser, dispatch, proveedores, editRowId, setEditRowId, setOpenNuevoProveedor, setOldRow }) => {
    const [openDialog, setOpenDialog] = React.useState(false);
    const [deleteRow, setDeleteRow] = useState({id:0});
    
    /*useEffect(() => {
        console.log('Proveedores: ', { proveedores })
    }, [proveedores])*/

    useEffect(() => {
        if(deleteRow.id > 0) {
            setOpenDialog(true);
        }
    }, [deleteRow])

    const handleResponse = (opcion) => {
        if(opcion == 'borrar') {
            handleDelete(deleteRow.id);
        }
        setDeleteRow({id:0});
    }

    const handleDelete = async (id) => {
        //console.log('row to delete: ', id);

        try {
            //console.log('handleDelete');

            const result = await borrarProveedor({ cmd: 'CMD_DELETE', idToDelete: id }, currentUser, dispatch);
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: "Proveedor eliminado." } });

            const newProveedores = proveedores.filter((p) => p.id !== id);
            //console.log({ newProveedores })
            //dispatch({ type: 'UPDATE_PRODUCTOS', payload: { rows: newProductos } });  //A users se envía el payload como {rows: valor}
            //setProveedores(newProveedores);
            dispatch({ type: 'UPDATE_PROVEEDORES', payload: {rows: newProveedores }});
        } catch (error) {

        }
    }

    function ccyFormat(num) {
        return `${num.toFixed(2)}`;
    }


    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Fragment>
            <Stack direction='column' bgcolor='white' height='100%' sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Box style={{ height: 600, maxWidth: '1000px', backgroundColor: 'white' }}>
                    <Typography variant="h5" component="h5" p={1} align='center'>
                        Detalle Proveedores
                    </Typography>
                    <Box mt={6}>
                        <TableContainer>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>Id</TableCell>
                                        <TableCell align='left' typeof='boolean'>Hab</TableCell>
                                        <TableCell align='left'>Proveedor</TableCell>
                                        <TableCell align='left'>Nombre Contacto</TableCell>
                                        <TableCell align='right'>Cel. Contacto</TableCell>
                                        <TableCell align='left'>Dias Visita</TableCell>
                                        <TableCell align='left'>Controles</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {proveedores?.map((p, i) => (
                                        <ReadOnlyRowPOS
                                            key={'rorp_' + i}
                                            row={p}
                                            setEditRowId={setEditRowId}
                                            setDeleteRow={setDeleteRow}
                                            setOpenNuevoProveedor={setOpenNuevoProveedor}
                                            setOldRow={setOldRow}
                                        />

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={proveedores.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />

                    </Box>
                </Box>
            </Stack>

            <ConfirmDialog 
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                deleteRow={deleteRow}
                handleResponse={handleResponse}
            />

        </Fragment>
    )
}

export default TablaProveedores